module.exports = __webpack_public_path__ + "img/store-title.684c5105.png";